module.exports = __webpack_public_path__ + "img/calendar.d9ba0093.png";